import "./ski-hire-bar.scss"
